/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AzureDevOpsListBuildResponse {
    getFixupPrototypeFunction() { return AzureDevOpsListBuildResponse.fixupPrototype; }

    static newInstance(model: Partial<AzureDevOpsListBuildResponse>): AzureDevOpsListBuildResponse {
        let obj = Object.assign(new AzureDevOpsListBuildResponse(), model);
        AzureDevOpsListBuildResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AzureDevOpsListBuildResponse>): AzureDevOpsListBuildResponse {
        if (!model) return null;
        return AzureDevOpsListBuildResponse.newInstance(<AzureDevOpsListBuildResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AzureDevOpsListBuildResponse) {
        if (!obj) return;

        models.AzureDevOpsListBuildResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AzureDevOpsListBuildResponse): boolean {
        Object.setPrototypeOf(obj, AzureDevOpsListBuildResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.builds) {
            for (let val of this.builds) {
                models.AzureDevOpsBuild.fixupPrototype(val);
            }
        }
    }

    /**
     * List of project name
     */
    builds: Array<models.AzureDevOpsBuild>;

}
